var RecordingExperimentClient = /** @class */ (function () {
    function RecordingExperimentClient(underlyingExperimentClient, recordedExperiments) {
        this.underlyingExperimentClient = underlyingExperimentClient;
        this.recordedExperiments = recordedExperiments;
        this.treatment = this.treatment.bind(this);
    }
    RecordingExperimentClient.prototype.treatment = function (_a) {
        var _this = this;
        var id = _a.id, experiment = _a.experiment, attributes = _a.attributes, defaultTreatment = _a.defaultTreatment;
        var underlyingTreatment = this.underlyingExperimentClient.treatment({
            id: id,
            experiment: experiment,
            attributes: attributes,
            options: {},
            defaultTreatment: defaultTreatment
        });
        // Record the results when promises are available
        Promise.all([
            underlyingTreatment.active,
            underlyingTreatment.changeNumber,
            underlyingTreatment.promise
        ]).then(function (_a) {
            var active = _a[0], changeNumber = _a[1], treatment = _a[2];
            return (_this.recordedExperiments[experiment] = { treatment: treatment, active: active, changeNumber: changeNumber });
        });
        return underlyingTreatment;
    };
    return RecordingExperimentClient;
}());

export { RecordingExperimentClient };
//# sourceMappingURL=recording.js.map
